/**
 * ENFAMI — Patchs officiels (catalogue PDF)
 * - UI catégories + images + prix CAD
 * - Mise à jour du prix affiché sur la PDP
 * - Propriétés panier + lignes compagnon si produit enfami-patchs existe
 */
(function () {
  'use strict';

  var bootEl = document.getElementById('enfami-patches-boot');
  var boot = {};
  try {
    boot = bootEl ? JSON.parse(bootEl.textContent) : {};
  } catch (e) {
    boot = {};
  }

  var state = {
    catalog: null,
    selected: {},
    basePrice: Number(boot.productPrice) || 0,
    compareAt: Number(boot.productCompare) || 0,
    activeCat: 'fifa-wc'
  };

  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, boot.moneyFormat || '${{amount}}');
    }
    return amount.toLocaleString('fr-CA', { style: 'currency', currency: boot.currency || 'CAD' });
  }

  function cadToCents(cad) {
    // Prix catalogue en CAD ; boutique ENFAMI = CAD. Si autre devise, Shopify Markets convertit au checkout pour les variantes.
    return Math.round(Number(cad) * 100);
  }

  function activeCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return String(boot.currency || boot.shopCurrency || 'CAD').toUpperCase();
  }

  function billingCurrency() {
    var cur = activeCurrency();
    if (cur === 'USD' || cur === 'EUR' || cur === 'CAD') return cur;
    /* Autres devises : facturer en CAD (prix PDF officiels) */
    return 'CAD';
  }

  function formatPdfPrice(cad) {
    var n = Number(cad) || 0;
    return n.toFixed(2).replace('.', ',') + ' $';
  }

  function patchVariantMeta(priceCad) {
    var variants = boot.patchVariants || {};
    var cur = billingCurrency();
    var key = String(Math.round(Number(priceCad))) + ' ' + cur;
    var fallbackCad = String(Math.round(Number(priceCad))) + ' CAD';
    var id = variants[key] || variants[fallbackCad] || variants[String(Math.round(Number(priceCad)))];
    if (!id) return null;
    return { id: id, priceCad: Number(priceCad) };
  }

  function patchPriceCents(p) {
    /* Affichage / total PDP : toujours le prix PDF en centimes de la devise active si possible.
       On utilise price_cad comme montant « étiquette » (5/8/10) converti via le taux Shopify
       uniquement pour l’aperçu PDP ; la facturation réelle passe par la variante calibrée. */
    var cad = Number(p.price_cad) || 0;
    var cur = activeCurrency();
    if (cur === 'CAD' || !window.Shopify || !Shopify.currency || !Shopify.currency.rate) {
      return Math.round(cad * 100);
    }
    /* Shopify.currency.rate = taux de la devise active par rapport à la devise boutique.
       Montant présentment ≈ montant_boutique * rate (selon versions). On préfère
       afficher le montant PDF nominal (5/8/10) dans la devise active. */
    return Math.round(cad * 100);
  }

  function patchPriceLabel(p) {
    return '+' + formatPdfPrice(p.price_cad);
  }

  function selectedList() {
    if (!state.catalog) return [];
    return state.catalog.patches.filter(function (p) {
      return !!state.selected[p.id];
    });
  }

  function surchargeCents() {
    return selectedList().reduce(function (sum, p) {
      return sum + patchPriceCents(p);
    }, 0);
  }

  function assetUrl(file) {
    var base = (boot.catalogUrl || '').replace(/enfami-patches-catalog\.json.*$/, '');
    return base + file;
  }

  function render(root) {
    if (!state.catalog) return;
    var tabs = root.querySelector('[data-efc-patch-tabs]');
    var panels = root.querySelector('[data-efc-patch-panels]');
    if (!tabs || !panels) return;

    tabs.innerHTML = '';
    panels.innerHTML = '';

    state.catalog.categories.forEach(function (cat, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'efc__patch-tab' + (cat.id === state.activeCat ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', cat.id === state.activeCat ? 'true' : 'false');
      btn.dataset.cat = cat.id;
      btn.textContent = cat.label;
      tabs.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'efc__patch-panel' + (cat.id === state.activeCat ? ' is-active' : '');
      panel.dataset.cat = cat.id;
      panel.setAttribute('role', 'tabpanel');
      panel.hidden = cat.id !== state.activeCat;

      var list = document.createElement('div');
      list.className = 'efc__patch-grid';

      state.catalog.patches
        .filter(function (p) {
          return p.category === cat.id;
        })
        .forEach(function (p) {
          var label = document.createElement('label');
          label.className =
            'efc__patch-card' +
            (state.selected[p.id] ? ' is-checked' : '') +
            (p._suggested ? ' is-suggested' : '');

          var input = document.createElement('input');
          input.type = 'checkbox';
          input.setAttribute('data-efc-patch-cb', '');
          input.value = p.name + ' (' + patchPriceLabel(p) + ')';
          input.dataset.patchId = p.id;
          input.dataset.priceCad = String(p.price_cad);
          input.checked = !!state.selected[p.id];

          var media = document.createElement('span');
          media.className = 'efc__patch-media';
          var img = document.createElement('img');
          img.src = assetUrl(p.image);
          img.alt = p.name;
          img.loading = 'lazy';
          img.width = 96;
          img.height = 96;
          img.onerror = function () {
            media.classList.add('is-fallback');
            img.remove();
          };
          media.appendChild(img);

          var body = document.createElement('span');
          body.className = 'efc__patch-body';
          body.innerHTML =
            '<strong class="efc__patch-name"></strong>' +
            '<small class="efc__patch-desc"></small>' +
            '<em class="efc__patch-price"></em>' +
            (p._suggested ? '<span class="efc__patch-suggest">Suggéré pour ce maillot</span>' : '');
          body.querySelector('.efc__patch-name').textContent = p.name;
          body.querySelector('.efc__patch-desc').textContent = p.description || '';
          body.querySelector('.efc__patch-price').textContent = patchPriceLabel(p);

          label.appendChild(input);
          label.appendChild(media);
          label.appendChild(body);
          list.appendChild(label);
        });

      panel.appendChild(list);
      panels.appendChild(panel);

      if (idx === 0 && !state.activeCat) state.activeCat = cat.id;
    });

    updateSummary(root);
    updatePriceUI();
  }

  function updateSummary(root) {
    var summary = root.querySelector('[data-efc-patch-summary]');
    var countEl = root.querySelector('[data-efc-patch-summary-count]');
    var totalEl = root.querySelector('[data-efc-patch-summary-total]');
    var list = selectedList();
    if (!summary) return;
    if (!list.length) {
      summary.hidden = true;
      return;
    }
    summary.hidden = false;
    if (countEl) countEl.textContent = list.length + (list.length > 1 ? ' patchs' : ' patch');
    if (totalEl) {
      var sumCad = list.reduce(function (s, p) { return s + (Number(p.price_cad) || 0); }, 0);
      totalEl.textContent = '+' + formatPdfPrice(sumCad);
    }
  }

  function findPriceNodes() {
    var primary = document.querySelector(
      [
        'product-price .price-item--sale',
        'product-price .price__regular .price-item--regular',
        'product-price .price-item--regular',
        '[ref="priceContainer"] .price-item--sale',
        '[ref="priceContainer"] .price-item--regular',
        '.product-information .price-item--sale',
        '.product-information .price-item--regular',
        '[data-product-price]'
      ].join(',')
    );
    return primary ? [primary] : [];
  }

  function updatePriceUI() {
    var total = state.basePrice + surchargeCents();
    var nodes = findPriceNodes();
    nodes.forEach(function (node) {
      if (!node.dataset.enfamiBaseText) {
        node.dataset.enfamiBaseText = node.textContent || '';
      }
      if (!node.dataset.enfamiBasePrice) {
        if (!state.basePrice) {
          var raw = (node.dataset.enfamiBaseText || '').replace(/[^\d.,]/g, '').replace(',', '.');
          var n = parseFloat(raw);
          if (n) state.basePrice = Math.round(n * 100);
        }
        node.dataset.enfamiBasePrice = String(state.basePrice);
      }
      node.textContent = money(total);
    });

    var note = document.querySelector('[data-enfami-patch-price-note]');
    if (!note) {
      var host =
        document.querySelector('product-price, [ref="priceContainer"], .price') ||
        document.querySelector('.product-information') ||
        null;
      if (host) {
        note = document.createElement('p');
        note.setAttribute('data-enfami-patch-price-note', '');
        note.className = 'efc__price-note';
        host.appendChild(note);
      }
    }
    if (note) {
      var extra = surchargeCents();
      if (extra > 0) {
        note.hidden = false;
        note.textContent = 'Dont ' + money(extra) + ' de patchs officiels';
      } else {
        note.hidden = true;
      }
    }

    window.EnfamiPatches = window.EnfamiPatches || {};
    window.EnfamiPatches.surchargeCents = surchargeCents();
    window.EnfamiPatches.selected = selectedList();
    document.dispatchEvent(
      new CustomEvent('enfami:patches-change', {
        detail: { surchargeCents: surchargeCents(), selected: selectedList(), totalCents: state.basePrice + surchargeCents() }
      })
    );
  }

  function bind(root) {
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-efc-patch-tabs] [data-cat]');
      if (tab) {
        state.activeCat = tab.dataset.cat;
        root.querySelectorAll('.efc__patch-tab').forEach(function (t) {
          var on = t.dataset.cat === state.activeCat;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('.efc__patch-panel').forEach(function (p) {
          var on = p.dataset.cat === state.activeCat;
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-efc-patch-cb]');
      if (!input) return;
      var id = input.dataset.patchId;
      if (!id) return;
      if (input.checked) state.selected[id] = true;
      else delete state.selected[id];
      var card = input.closest('.efc__patch-card');
      if (card) card.classList.toggle('is-checked', input.checked);
      updateSummary(root);
      updatePriceUI();
    });
  }

  function getProps() {
    var list = selectedList();
    if (!list.length) return {};
    var props = {
      Patches: list
        .map(function (p) {
          return p.name + ' (+' + formatPdfPrice(p.price_cad) + ')';
        })
        .join(' | '),
      '_enfami_patch_ids': list.map(function (p) { return p.id; }).join(',')
    };
    if (!boot.patchProductAvailable) {
      props['Supplément patchs (non facturé)'] =
        money(surchargeCents()) + ' — produit enfami-patchs manquant';
    }
    return props;
  }

  function companionItems() {
    var items = [];
    if (!boot.patchProductAvailable) {
      try {
        console.warn('[ENFAMI] Produit compagnon enfami-patchs indisponible — patchs non facturés.');
      } catch (e) { /* noop */ }
    } else {
      selectedList().forEach(function (p) {
        var meta = patchVariantMeta(p.price_cad);
        var vid = meta && meta.id;
        if (!vid) {
          try {
            console.warn('[ENFAMI] Pas de variante patch pour ' + p.price_cad, boot.patchVariants);
          } catch (e) { /* noop */ }
          return;
        }
        items.push({
          id: Number(vid),
          quantity: 1,
          properties: {
            Patch: p.name,
            '_enfami_patch_id': p.id,
            '_bundle_parent': 'jersey',
            '_enfami_companion': 'patch'
          }
        });
      });
    }
    return items;
  }

  function photoCompanionItem() {
    if (!boot.photoProductAvailable) return null;
    var variants = boot.photoVariants || {};
    var cur = billingCurrency();
    var key = '15 ' + cur;
    var vid = variants[key] || variants['15 CAD'] || boot.photoVariantId;
    if (!vid) return null;
    return {
      id: Number(vid),
      quantity: 1,
      properties: {
        'Flocage photo': '+' + formatPdfPrice(boot.photoPriceCad || 15),
        '_enfami_companion': 'photo',
        '_bundle_parent': 'jersey'
      }
    };
  }

  // Expose for configurator cart hook
  window.EnfamiPatches = {
    getProps: getProps,
    companionItems: companionItems,
    photoCompanionItem: photoCompanionItem,
    photoAvailable: function () {
      var variants = boot.photoVariants || {};
      return !!(boot.photoProductAvailable && (variants['15 CAD'] || variants['15 USD'] || variants['15 EUR'] || boot.photoVariantId));
    },
    photoPriceMoney: function () {
      return '+' + formatPdfPrice(boot.photoPriceCad || 15);
    },
    surchargeCents: function () { return surchargeCents(); },
    selected: function () { return selectedList(); },
    formatPdfPrice: formatPdfPrice
  };

  // Keep base price in sync with variant changes
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    if (typeof v.price === 'number') state.basePrice = v.price;
    updatePriceUI();
  });

  function init() {
    var root = document.querySelector('[data-efc-patches-root]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    bind(root);

    var url = boot.catalogUrl;
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (catalog) {
        state.catalog = catalog;
        // Suggest club-related UCL badges via product title
        var title = (document.querySelector('h1, .product-title, [data-product-title]') || {}).textContent || '';
        title = title.toLowerCase();
        catalog.patches.forEach(function (p) {
          (p.clubs || []).forEach(function (club) {
            if (title.indexOf(String(club).toLowerCase()) !== -1) {
              // soft highlight only — do not auto-check (price impact)
              p._suggested = true;
            }
          });
        });
        render(root);
      })
      .catch(function () {
        /* silent */
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
